import { action, computed, extendObservable, observable, runInAction } from 'mobx';
import { computedFn } from 'mobx-utils';

import { ConfigUpdate } from 'tm3-core/api.dtos';
import EConfigKeys from 'tm3-core/enums/config-enum';

import BaseStore from '../base-store';

class ConfigStore extends BaseStore<any> {
  configMap = observable.map<string, string>();

  readonly isEnabled = computedFn((key: string): boolean => {
    return this.configMap.get(key)?.toLowerCase() === 'true';
  });

  readonly getFloat = computedFn((key: string, fallback: number): number => {
    return this.configMap.get(key)?.toFloat() ?? fallback;
  });

  readonly getInt = computedFn((key: string, fallback: number): number => {
    return this.configMap.get(key)?.toInt() ?? fallback;
  });

  @computed
  get config() {
    return this.configMap.toJSON();
  }

  @computed
  get vatRate(): number {
    return this.getFloat(EConfigKeys.VAT_RATE, 0);
  }

  @computed
  get TwoFactorEnabled() {
    return this.isEnabled(EConfigKeys.TwoFactorAuthEnabled);
  }

  @action.bound
  update(entries: Record<string, string>): void {
    this.configMap.merge(entries);
    extendObservable(this.config, this.configMap.toJSON());
  }

  @action.bound
  updateValue(key: string, value: string): void {
    this.configMap.set(key, value);
    extendObservable(this.config, this.configMap.toJSON());
  }

  @action.bound
  async saveValue(key: string): Promise<void> {
    const { result } = await this.client.post(
      new ConfigUpdate({
        description: key,
        value: this.configMap.get(key)
      })
    );

    runInAction(() => {
      this.update(result);
    });
  }
}

export default ConfigStore;
